import { Text } from '@thanx/uikit/text'
import type { OrderSnapshot } from 'api/recoveryAi.types'
import ModalContainer from 'components/ModalContainer'
import OrderSnapshotReceipt from 'components/OrderSnapshotReceipt'
import { buildTranslate } from 'locales'
import React from 'react'
import { formatDateTime } from 'utilities/dateFormatters'

const t = buildTranslate('components.order_summary')

type Props = {
  isOpen: boolean
  onClose: () => void
  order: OrderSnapshot
}

const ReceiptModal = ({ isOpen, onClose, order }: Props) => {
  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      title={t('receipt.heading', {
        orderNumber: order.orderNumber ?? t('empty'),
      })}
      // Reuses the house date+time format already shown for this same field in
      // OverviewTab/CaseDetail rather than inventing a fourth ad-hoc format (the
      // codebase already carries three in utilities/date.ts, each flagged with a
      // reconciliation-debt comment) — this deliberately doesn't match the
      // Figma's exact "MM/DD/YYYY h:mmA zz" string, since no merchant/order
      // timezone is threaded to this component.
      subtitle={formatDateTime(order.orderDate)}
      hideCancel
      showBottomProceed
      proceedText={buildTranslate('shared_words')('close')}
      onProceed={onClose}
    >
      {/* mt-xl (48px) matches the Figma spec's header-to-content gap. */}
      <Text.SmallCaps3 tag="div" color="grey50" bold className="mt-xl">
        {t('receipt.your_items')}
      </Text.SmallCaps3>

      <OrderSnapshotReceipt order={order} />
    </ModalContainer>
  )
}

export default ReceiptModal
